import { render, staticRenderFns } from "./chart_weblog.vue?vue&type=template&id=bc17685e&"
import script from "./chart_weblog.vue?vue&type=script&lang=js&"
export * from "./chart_weblog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {DetailChart: require('/src/components/detail/mobile/detail_chart.vue').default,DetailWeblog: require('/src/components/detail/mobile/detail_weblog.vue').default})
